import React from 'react';

const InputField = ({ label, type = 'text', value, onChange, placeholder, maxLength, min, small, icon }) => (
  <div>
    <label className="block text-gray-400 text-sm mb-1">{label}</label>
    <div className="relative">
      {icon && <span className="absolute left-3 top-1/2 transform -translate-y-1/2">{icon}</span>}
      <input
        type={type}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        className={`w-full ${icon ? 'pl-10' : 'px-4'} py-2 bg-[#0F172A] border border-[#2D5A8F] rounded-lg text-white focus:border-[#FFD700] focus:outline-none ${small ? 'text-sm' : ''}`}
        placeholder={placeholder}
        maxLength={maxLength}
        min={min}
      />
    </div>
  </div>
);

export default InputField;
